var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E6E9F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4984 20.125L20.2609 23.35H19.9859C18.5903 23.0487 17.2467 22.5433 15.9984 21.85C14.7652 21.1856 13.6364 20.3432 12.6484 19.35C10.6299 17.3293 9.25914 14.7531 8.71094 11.95V11.6625L11.8609 8.5L15.2234 11.825L13.3734 13.675C13.5355 14.0092 13.7149 14.3346 13.9109 14.65L13.1484 15.4125C12.8026 14.8931 12.5016 14.3453 12.2484 13.775L12.0984 13.5L13.7109 11.825L11.8609 9.9625L9.81094 12.0125C10.075 13.2042 10.4953 14.3558 11.0609 15.4375C11.6866 16.6001 12.4782 17.6655 13.4109 18.6C14.3242 19.52 15.3689 20.2993 16.5109 20.9125C17.5908 21.4821 18.743 21.9026 19.9359 22.1625L21.9984 20.0875L20.1484 18.2625L18.4984 19.8875L18.1859 19.75C16.9007 19.1654 15.7352 18.3474 14.7484 17.3375C14.5105 17.0995 14.2852 16.8491 14.0734 16.5875L14.8234 15.8375C15.0352 16.0991 15.2605 16.3495 15.4984 16.5875C16.3295 17.416 17.2927 18.1003 18.3484 18.6125L20.1484 16.75L23.4984 20.125Z",
    fill: "#8990A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 11.5,
    stroke: "#E6E9F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallGrey);
export default __webpack_public_path__ + "static/media/callGrey.23bdd48023d27ae85d56b7931df8486c.svg";
export { ForwardRef as ReactComponent };